enum Contexts {
  SUCCESS = 'success',
  ERROR = 'error',
  INFO = 'info',
  FEEDBACK = 'feedback',
}

export { Contexts }
